"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = useAuth;
const react_1 = require("react");
const AuthContext_1 = require("./AuthContext");
/**
 * Read the current auth state and lifecycle actions.
 *
 * Must be called inside a tree wrapped by `<AuthProvider>`.
 *
 * @example
 *   const { isLoggedIn, logoutUser } = useAuth();
 */
function useAuth() {
    return (0, react_1.useContext)(AuthContext_1.AuthContext);
}
